import styled from 'styled-components';

/** Takes the space left over by the header, sub-header and footer, so the footer stays pinned. */
export const TableArea = styled.div`
	flex: 1;
	min-height: 0;
	width: 100%;
	overflow: auto;
`;
